import React from 'react';
import Section from '../content/section/section';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useTranslation } from 'react-i18next';
import { getSiteConfig } from '../../../siteConfig';
import { GetTripAdvisorJSON } from './hotel_tripadvisor';

const HotelReviews = ({ blok, hotel }) => {
  const { t } = useTranslation('hotel');
  const locale = getSiteConfig().locale || 'default';
  const widths = {
    '25%': 'w-1/2 sm:w-1/4',
    '33%': 'w-1/2 sm:w-1/3',
    '50%': 'w-full md:w-1/2',
    '66%': 'w-full sm:w-2/3',
    '75%': 'w-full sm:w-3/4',
    '100%': 'w-full',
  };

  const showTripAdvisorBlock =
    hotel.tripadvisor &&
    hotel.tripadvisor.rating &&
    !blok.hide_tripadvisor_ratings;

  const tripAdvisorBlock = GetTripAdvisorJSON({
    blok: { _uid: `ta_${blok._uid}`, width: 'w-1/3' },
    hotel: hotel,
  });
  const fakeCard = (quote, index) => {
    const width = quote.comment.length > 300 ? 'w-1/2' : 'w-1/3';
    const cardId = `ca_${index}`;
    const commentID = `co_${index}`;
    return {
      _uid: cardId,
      name: '',
      width: width,
      blocks: [
        {
          _uid: commentID,
          text: {
            type: 'doc',
            content: [
              {
                type: 'blockquote',
                content: [
                  {
                    type: 'paragraph',
                    content: [
                      {
                        text: quote.comment,
                        type: 'text',
                        marks: [
                          {
                            type: 'italic',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                type: 'paragraph',
                content: [
                  {
                    text: `— ${quote.name} - ${new Date(
                      quote.date,
                    ).toLocaleDateString(locale, {
                      year: 'numeric',
                      month: 'long',
                    })}`,
                    type: 'text',
                    marks: [
                      {
                        type: 'italic',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          color: 'text-black',
          width: 'auto',
          component: 'text',
          align_text: 'text-left',
          background_color: 'transparent',
        },
      ],
      height: 'full',
      labels: [],
      looping: false,
      component: 'card',
      vertical_align: 'items-start',
      background_color: 'yellow',
    };
  };

  const quotes = hotel.customerComments
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .map((quote, i) => {
      return fakeCard(quote, i);
    });

  const reviewInfo = {
    _uid: `r_${blok._uid}`,
    name: '',
    width: 'w-1/3',
    blocks: [
      {
        _uid: 1,
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: {
                level: 3,
              },
              content: [
                {
                  text: t('Guest reviews'),
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: t('Guest review description'),
                  type: 'text',
                },
              ],
            },
          ],
        },
        color: 'text-black',
        width: 'w-full',
        height: 'full',
        component: 'text',
        align_text: 'text-left',
        background_color: 'transparent',
      },
    ],
    height: 'full',
    labels: [],
    looping: false,
    component: 'card',
    vertical_align: 'items-start',
    background_color: 'yellow',
  };

  let fakeBlocks = [];
  if (showTripAdvisorBlock) {
    fakeBlocks.push(tripAdvisorBlock);
  }
  if (quotes.length > 0) {
    fakeBlocks.push(reviewInfo);
    fakeBlocks = fakeBlocks.concat(quotes);
  }

  const fakeSection = {
    _uid: blok._uid,
    width: widths[blok.width] || 'w-full',
    blocks: fakeBlocks,
    height: 'sectionHeightAuto',
    component: 'section',
    background_color: 'transparent',
    horizontal_scroll: true,
  };

  return (
    <div
      className="mt-12 col-span-12 scroll-mt-12"
      {...storyblokEditable(blok)}
      id="reviews"
    >
      <div className="max-w-screen-xl mx-auto px-4 md:px-8 mb-4">
        <h1>{t('Guest reviews')}</h1>
      </div>
      <Section blok={fakeSection} />
    </div>
  );
};

export default HotelReviews;
